import Vue from "vue";

import header from "../components/header";
import footer from "../components/footer";
import sideOptions from "../components/sideOptions";
import Level3 from "../components/index/Level3";
import Advantage from "../components/index/Advantage";
import Solutions from "../components/index/Solutions";
import News from "../components/index/News";
import Cases from "../components/index/Cases";

Vue.component("DpHeader", header);
Vue.component("DpSideOptions", sideOptions);
Vue.component("DpFooter", footer);
Vue.component("Level3", Level3);
Vue.component("Advantage", Advantage);
Vue.component("Solutions", Solutions);
Vue.component("News", News);
Vue.component("Cases", Cases);
